<h2 mat-dialog-title>Two Factor Authentication</h2>
<mat-dialog-content>
    <p>
      Two-factor authentication (i.e. 2FA) provides increased login security for you to connect to the Document Portal. The
      MFA process is designed to provide additional measures to confirm your identity.
    </p>
    <p>
      A normal login requires that you only use a username (or client id) and password, but with MFA you are also required
      to provide a “one-time token” using an authenticator mobile app (such as Google Authenticator).
    </p>
    <p>
      When MFA is first setup, you will need to configure your authenticator mobile app by entering the provided key or
      scanning the given QR code. Once setup, the authenticator mobile app will provide you with “one-time tokens” for
      future logins.
    </p>
    <p>If you need assistance with using MFA, please contact your agent.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
